import React from 'react';
import { Edit, SimpleForm } from 'react-admin';
import { FormToolbar } from '../../common/FormToolbar';
import { AcademicContentFormFields } from './AcademicContentForm';

export const AcademicContentEdit = (props: any) => (
  // mutationMode="pessimistic" rather than react-admin's optimistic default:
  // saving here can upload a 30 MB PDF, and an optimistic edit would report
  // success before the file had finished transferring.
  <Edit undoable={false} mutationMode="pessimistic" title="Edit Academic Content" {...props}>
    <SimpleForm className="main-form" toolbar={<FormToolbar {...props} hasDelete={true} />}>
      <AcademicContentFormFields />
    </SimpleForm>
  </Edit>
);
